import React from "react";
import styles from "./FooterButton.module.scss";
const FooterButton = ({ showSearchModalHandler, children }) => {
  return (
    <button onClick={showSearchModalHandler} className={styles.footerButton}>
      {children}
    </button>
  );
};

export default FooterButton;
